import {
  Zap,
  ShoppingBag,
  Clock,
  Shield,
  CreditCard,
  SlidersHorizontal,
  Sofa,
  FolderOpen,
  PencilLine,
} from 'lucide-react';

export const creditPacks = [
  {
    name: 'Mini Pack',
    packKey: 'mini',
    price: 5,
    images: 30,
    payhipUrl: 'https://payhip.com/b/290pG',
    checkoutUrl: 'https://myroomai.gumroad.com/l/MiniPack',
  },
  {
    name: 'Standard Pack',
    packKey: 'standard',
    price: 10,
    images: 130,
    recommended: true,
    payhipUrl: 'https://payhip.com/b/Vrh5t',
  },
  { name: 'Designer Pack', packKey: 'designer', price: 15, images: 200, perImageRate: 0.06, payhipUrl: 'https://payhip.com/b/8hpJs' },
  { name: 'Studio Pack', packKey: 'studio', price: 25, images: 400, payhipUrl: 'https://payhip.com/b/jz6D8' },
];

export const creditPackBenefits = [
  { icon: Zap, label: 'Instant delivery' },
  { icon: ShoppingBag, label: 'One-time purchase' },
  { icon: Clock, label: 'Use anytime' },
];

/** Below pricing: payment trust + same Lucide icons as Features page (compact copy). */
export const creditsBottomHighlights = [
  {
    icon: Shield,
    title: 'Secure checkout',
    desc: 'Your payment is safe and encrypted.',
  },
  {
    icon: CreditCard,
    title: 'One-time payment',
    desc: 'No subscriptions. Pay once.',
  },
  {
    icon: SlidersHorizontal,
    title: 'Full Design Control',
    desc: 'Choose style, colors, furniture, and decor.',
  },
  {
    icon: Sofa,
    title: 'Many Interior Styles',
    desc: 'Modern, Luxury, Japandi, Coastal, and more.',
  },
  {
    icon: FolderOpen,
    title: 'Save Projects',
    desc: 'Keep your room designs in your account.',
  },
  {
    icon: PencilLine,
    title: 'Edit Designs',
    desc: 'Reopen projects and improve results anytime.',
  },
];
